module.exports = __webpack_public_path__ + "img/logo-tws-dark.30dfc71c.svg";